import { useMe } from '@/portal/shared/hooks/useMe';
import { usePortalAccess } from '@/portal/shared/hooks/usePortalAccess';
import { InvestmentsSection } from '../components/InvestmentsSection';
import { FundCarrySection } from '../components/FundCarrySection';

export function PortalDashboardPage() {
  const { data: me } = useMe();
  const { canAccess } = usePortalAccess();

  const hasInvestorContext = me?.investor != null;

  return (
    <div className="space-y-6">
      {hasInvestorContext && <InvestmentsSection />}
      {canAccess('fund_carry') && <FundCarrySection />}
    </div>
  );
}
